import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import lottie from "lottie-web";
import { module as BaseModule } from "modujs";

gsap.registerPlugin(ScrollTrigger);

export default class extends BaseModule {
  init() {
    const file = this.el.dataset.file;
    
    if (!file) {
      console.warn("Lottie module: data-file attribute is required");
      return;
    }

    // Create container for Lottie animation
    const container = this.el;
    
    // Load and initialize Lottie animation
    this.animation = lottie.loadAnimation({
      container: container,
      renderer: "svg",
      loop: false,
      autoplay: false,
      path: file,
    });

    // Listen for custom event to play animation forward
    this.handlePlayEvent = (event) => {
      const lottieId = this.el.dataset.id;
      if (event.detail && event.detail.id === lottieId) {
        // Reset animation before playing forward
        this.animation.goToAndStop(0, true);
        this.animation.setDirection(1);
        this.animation.setSpeed(1);
        this.animation.play();
      }
    };
    
    // Listen for custom event to play animation in reverse
    this.handleReverseEvent = (event) => {
      const lottieId = this.el.dataset.id;
      if (event.detail && event.detail.id === lottieId) {
        this.animation.setDirection(-1);
        this.animation.setSpeed(2);
        this.animation.play();
      }
    };
    
    this.el.addEventListener("lottie:play", this.handlePlayEvent);
    this.el.addEventListener("lottie:reverse", this.handleReverseEvent);

    // Create ScrollTrigger to play animation when scrolled into view (only if no data-id is set)
    if (!this.el.dataset.id) {
      ScrollTrigger.create({
        trigger: this.el,
        start: "top bottom",
        once: true,
        onEnter: () => {
          this.animation.play();
        },
      });
    }
  }

  destroy() {
    if (this.handlePlayEvent) {
      this.el.removeEventListener("lottie:play", this.handlePlayEvent);
    }
    if (this.handleReverseEvent) {
      this.el.removeEventListener("lottie:reverse", this.handleReverseEvent);
    }
    if (this.animation) {
      this.animation.destroy();
    }
  }
}
